'use client';

import { Box, SystemIcon, Typography } from '@wishket/design-system';

import { Icon } from '@/shared/Components';

interface SettingStartPageGuideProps {
  browser: 'samsung' | 'naver' | 'chrome' | 'safari';
  onClose: () => void;
}

const SettingStartPageGuide = ({
  browser,
  onClose,
}: SettingStartPageGuideProps) => {
  const isChrome = browser === 'chrome';

  return (
    <Box
      className="flex w-[calc(100%_-_40px)] items-start justify-between gap-1.5 rounded-2xl bg-w-bluegray-500/85 px-5 py-4 backdrop-blur-[2px] [-webkit-backdrop-filter:blur(2px)]"
      data-testid="setting-start-page-guide-box"
    >
      <Box className="w-full items-center break-keep text-w-white">
        <Typography variant="body1">
          {isChrome ? '위에 있는 ' : '아래에 있는 '}
        </Typography>
        <Box className="-mb-0.5 inline-block">
          <Icon name={`menu_${browser}`} />
        </Box>
        <Typography variant="body1">
          {` 눌러 `}
          <Typography variant="body1" className="font-bold">
            [홈 화면에 추가]
          </Typography>
          하면 요즘IT 바로가기를 만들 수 있어요!
        </Typography>
      </Box>
      <Box onClick={onClose} data-testid="setting-start-page-guide-close-btn">
        <SystemIcon
          name="medium_delete"
          className="mt-1 shrink-0 text-w-white"
        />
      </Box>
    </Box>
  );
};

export default SettingStartPageGuide;
